import React from 'react'
import { Modal, Button, Alert } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'
import Text from './TermsAndConditionsText'

const NewTCsModal = (props) => {
  const {
    isOpen, acceptClick, error, close
  } = props

  return (
    <Modal
      header={{
        label: 'Terms and conditions',
        isDismissible: true,
      }}
      isOpen={isOpen}
      onClose={close}
      size="xl"
      contentHeight="full"
      renderFooter={(
        <Button type="button" variant="primary" isFullWidth onClick={acceptClick}>
          I agree to the T&Cs
        </Button>
      )}
    >
      <div className="dsib-termsAndConditionsModal__content">
        <Text />
        {error
          ? (
            <div className="dsib-termsAndConditionsModal__error">
              <Alert status="error" isOpen message={error} />
            </div>
          )
          : null}
      </div>
    </Modal>
  )
}

NewTCsModal.propTypes = {
  isOpen: PropTypes.bool,
  acceptClick: PropTypes.func.isRequired,
  error: PropTypes.string,
  close: PropTypes.func
}

NewTCsModal.defaultProps = {
  isOpen: false,
  error: '',
  close: null
}

export default NewTCsModal
